import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useCraftingWithGameplayTier = () => {
  const { sport } = useSportContext();
  const {
    flags: {
      craftingWithGameplayTier = {
        football: false,
        nba: false,
        baseball: false,
      },
    },
  } = useFeatureFlags();

  return !!craftingWithGameplayTier[sport.toLowerCase()];
};
